var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-campaign-targeting-rule',[_c('div',[_c('strong',[_vm._v("Visitors who are using:")]),_c('div',[_vm._v(_vm._s(_vm.data.map(function (d) { return _vm.osMap[d]; }).join(" or ")))])])])}
var staticRenderFns = []

export { render, staticRenderFns }